module.exports = __webpack_public_path__ + "img/loading.10090ea0.svg";